module.exports = __webpack_public_path__ + "img/empty-store-list-image.9d0d5919.svg";